import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    title: 'Identifica los Ladrones',
    desc: 'Localiza los picos de glucosa y cortisol que están vaciando tu batería.'
  }, {
    title: 'Aplica el Protocolo',
    desc: 'Implementa los micro-estímulos de luz y activación térmica cada mañana.'
  }, {
    title: 'Mantén el Vigor',
    desc: 'Sigue el orden nutricional de sostenimiento para una energía lineal durante 16 horas.'
  }];
  return <section className="py-24 bg-[#275a3a] relative border-y border-white/8 overflow-hidden" data-id="element-71">
      {/* Decorative Elements */}
      <span className="absolute top-8 left-8 text-4xl opacity-[0.06] pointer-events-none select-none" data-id="element-72">
        🔍
      </span>
      <span className="absolute bottom-8 right-8 text-4xl opacity-[0.07] pointer-events-none select-none" data-id="element-73">
        🌅
      </span>
      <span className="absolute top-1/2 right-4 text-3xl opacity-[0.05] pointer-events-none select-none" data-id="element-74">
        🥑
      </span>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-76">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-77">
            Cómo funciona en{' '}
            <span className="text-emerald-400" data-id="element-78">3 pasos simples</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12 relative" data-id="element-79">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[2px] bg-gradient-to-r from-emerald-500/0 via-emerald-500/30 to-emerald-500/0" data-id="element-80" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className="relative bg-[#2f5c3d] p-8 rounded-2xl border border-white/8 pt-14" data-id="element-81">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 rounded-full bg-[#1e3d2a] border-2 border-emerald-500 flex items-center justify-center text-2xl font-bold text-emerald-400 shadow-[0_0_15px_rgba(16,185,129,0.3)]" data-id="element-82">
                {index + 1}
              </div>
              <h3 className="text-xl font-bold text-white mb-4 text-center" data-id="element-83">
                {step.title}
              </h3>
              <p className="text-gray-400 text-center leading-relaxed" data-id="element-84">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}